import translate from './translatorEnvoieMail';

export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    if (error.members) {
      messages.push({
        message: translate(error.members[0]),
      });
    }
    if (error.message.indexOf('EMAIL') === 0) {
      messages.push({
        message: 'mail.error.email',
      });
    }
    if (error.message.indexOf('Each email address in the personalization block should be unique between to, cc, and bcc') === 0) {
      messages.push({
        message: 'mail.error.uniqueEmail',
      });
    }
  });
}
